import { createSlice } from '@reduxjs/toolkit';
import { login, register } from './authThunk';
import { toast } from 'react-toastify';
import { authorizeMe } from 'src/constant/axios_config';


const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    // Add any other reducers you might need
    handleRefresh: (state) => {
      let token = localStorage.getItem("token") || "";
      let user = localStorage.getItem("user") || null;
      if (token && token !== "undefined" && user) {
        state.isLoggedIn = true;
        state.user = JSON.parse(user)
        authorizeMe(token);
      }
      else {
        state.isLoggedIn = false
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.user?.role === "admin") {
          state.user = action.payload?.user;
          localStorage.setItem("token", action.payload?.tokens?.access?.token)
          localStorage.setItem("user", JSON.stringify(action.payload?.user))
          authorizeMe(action.payload?.tokens?.access?.token)
        } else toast.error("Only admins can log in.")
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        if (action.payload?.message) toast.error(action.payload?.message)
        else toast.error("Incorrect email or password.")
      })
      .addCase(register.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(register.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});


export default authSlice.reducer;
export const authActions = authSlice.actions;